import axios from 'axios';
import config from 'config';
import store from '@/vuex/index';
import {
  getBaseUrl,
  getH5Platform,
  getQueryString,
  isIOS,
  isZhenxuanService,
  getZhenxuanBaseUrl,
} from '@/utils/environment';
import { NativeService } from '@/service/native/nativePluginService';
import { interceptors, interceptorsResponse } from './interceptors';
import basicAuthorizationMap from '../service/native/basic-authorization';
import { getCurrentRouters, hlyRouter } from 'utils/routerTools';
import { randomString } from '@/utils/index';
let instance;
let noBaseServrerInstance;
let invalidTokenCount = 0;
import { addPending, removePending } from '@/utils/fetch-cancel';

// 清除掉url上指定参数
function clearUrlKey(url, key) {
  try {
    const urlArray = url.split('?');
    let baseInfo = urlArray[0];
    let search = urlArray[1];
    const regexp = new RegExp(`&?${key}=(\\w|-)*`, 'igm');
    search = search.replace(regexp, '');
    // 去掉第一个&符
    if (search.indexOf('&') === 0) {
      search = search.slice(1, search.length);
    }
    // 如果只有一个参数 清除掉之后就不应该拼?号了
    return `${baseInfo}${search ? '?' + search : ''}`;
  } catch (error) {
    return url;
  }
}

/*
// 扩展字段配置管控
const controlUrls = {
  injectUrl: [
    /\/api\/v2\/users\/oids/, // 获取用户详情，/api/v2/users/oids
  ],
  injectBody: [
    /\/api\/users\/v3\/search/, // 选择人员，/api/users/v3/search
  ],
};

// 接入扩展字段，添加参数withCustomValues
function getCustomOptions(options) {
  let url = options.url;
  if (!url) return options;
  let withCustomValues = !!controlUrls.injectUrl.find((item) => item && item.test(url));
  if (withCustomValues && !url.includes('withCustomValues=')) {
    const reg = /\?+/;
    url += reg.test(url) ? '&' : '?';
    url += `withCustomValues=${withCustomValues}`;
    options.url = url;
  } else {
    withCustomValues = !!controlUrls.injectBody.find((item) => item && item.test(url));
    if (withCustomValues) {
      if (!options.data) options.data = {};
      options.data.withCustomValues = true;
    }
  }
  return options;
}
 */

function goLoginPage() {
  if (getH5Platform() === 'webapp') {
    let codeUrl = getQueryString('code');
    let isTrial = getQueryString('isTrial');
    if (isTrial === 'Y') {
      hlyRouter.replace({ name: 'trialLogin' });
    } else if (!codeUrl) {
      hlyRouter.replace({ name: 'login' });
    }
  }
}

function setCorpid(options) {
  let companyOID = getQueryString('companyOID'),
    corpId = getQueryString('corpId') || sessionStorage.getItem('corpId'),
    loginType = getQueryString('loginType');
  //周宗云需要对企业微信和钉钉所有接口的header上都加corpid
  if (loginType === 'wx') {
    options.headers = {
      corpid: corpId || companyOID,
    };
  } else if (['dd', 'feishu', 'welink', 'yzj'].includes(loginType)) {
    options.headers = {
      corpid: corpId,
    };
  }
  return options;
}

function getInstance({ noBaseServer = false, isZhenxuan = false } = {}) {
  let baseURL = getBaseUrl();
  // 宗云需求：钉钉 dingtalk/common 开头的接口不加v1
  if (noBaseServer) {
    baseURL = baseURL.replace('/v1', '');
  }
  // 甄选的baseURL 单独处理  除了子应用  其他平台不需要baseUrl
  if (isZhenxuan) {
    const isSubApp = getH5Platform() === 'cd';
    baseURL = isSubApp ? getZhenxuanBaseUrl() : '';
  }
  let options = {
    timeout: 20000 * 6, // 超时
    baseURL: baseURL,
  };

  options = setCorpid(options);

  return axios.create(options);
}

// function getFlybackInstance () {
//   let options = {
//     timeout: 20000 * 6, // 超时
//     baseURL: getBaseUrl() + '/hand',
//   };
//
//   options = setCorpid(options);
//
//   return axios.create(options);
// }

let cashRreshToken = null;
let loginType = getQueryString('loginType');
let clientNameMap = {
  dd: 'helios-dd',
  wx: 'helios-wx',
  wxmp: 'helios-wxfw',
  feishu: 'helios-feishu',
  webapp: 'helios-webapp',
  yzj: 'helios-yzj',
  welink: 'helios-welink',
};
let clientName = clientNameMap[loginType] || 'helios-app';

const _resetInstance = () => {
  instance = undefined;
};
let clientBasic = '';

function getClientBasic() {
  if (clientBasic) {
    return clientBasic;
  }
  let result = basicAuthorizationMap.clientWebApp;
  let clientMap = {
    cd: basicAuthorizationMap.clientApp,
    wx: basicAuthorizationMap.clientWechat,
    wxmp: basicAuthorizationMap.clientWechat,
    welink: basicAuthorizationMap.clientWeLink,
    dd: basicAuthorizationMap.clientDingTalk,
    webapp: basicAuthorizationMap.clientWebApp,
    feishu: basicAuthorizationMap.clientFeishu,
    yzj: basicAuthorizationMap.clientYzj,
  };
  if (clientMap[loginType]) {
    result = clientMap[loginType];
  }
  clientBasic = result;
  return result;
}

let refreshToken = (options) => {
  return new Promise((resolve, reject) => {
    if (!cashRreshToken) {
      let url = '/auth/oauth/token';
      let clientBasic = getClientBasic();
      const appKey = getQueryString('appKey');
      let params = {
        client_id: clientBasic.client_id,
        client_secret: clientBasic.client_secret,
        refresh_token: store.getters.getUserToken.refresh_token,
        grant_type: 'refresh_token',
      };
      //钉钉自建应用唯一标识
      if (appKey) {
        params.appKey = appKey;
      }
      cashRreshToken = instance({
        url,
        method: 'POST',
        params,
      });
    }

    cashRreshToken
      .then((res) => {
        if (res.status == 200) {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.access_token;
          store.commit('storeToken', res.data);
          browseHttp(options).then(
            (res) => {
              resolve(res);
            },
            (err) => {
              reject(err);
            }
          );
        }
        cashRreshToken = null;
      })
      .catch((err) => {
        reject(err);
        cashRreshToken = null;
      });
  });
};

function isAliCloud() {
  let loginType = getQueryString('loginType');
  let isAliCloud = false;
  //let isDingtalkDD =  window.location.href.indexOf('dingtalk-dd.huilianyi.com') > -1;
  let userToken = store.getters.getUserTokenNoCache;
  let realmIdList = ['639514855899537001'];
  if (
    userToken &&
    realmIdList.indexOf(userToken.realm_id) > -1 &&
    ['cd', 'webapp', 'dd', 'welink'].indexOf(loginType) === -1
  ) {
    isAliCloud = true;
  }
  //console.log('isAliCloud', isAliCloud);
  return isAliCloud;
}

function isTcCloud() {
  let isTcCloud = false;
  let realmIdList = ['1005671681484599307'];
  let tenantProfile = store.getters.getTenantProfile;
  let currentRealmId = tenantProfile && tenantProfile.realmId;
  if (realmIdList.indexOf(currentRealmId) > -1) {
    isTcCloud = true;
  }
  return isTcCloud;
}

function browseHttp(options) {
  let loginType = getQueryString('loginType');
  // store.commit("increaseLoading")
  addPending(options);
  return new Promise((resolve, reject) => {
    let token, language, realmId;
    if (store.getters.getUserToken) {
      token = store.getters.getUserToken.access_token;
      realmId = store.getters.getUserToken.realm_id;
    }

    if (store.getters.getSelectedLanguage) {
      language = store.getters.getSelectedLanguage;
    }

    if (!options.headers) {
      let headers = {
        Authorization: 'Bearer' + token,
        'x-helios-client': clientName,
        'x-helios-router': window.location.hash.split('?')[0],
        'sub-app-publish-date': config.subAppVersionDate || '',
      };
      realmId && (headers.realmId = realmId);
      options.headers = headers;
    }

    // currentPageKey 和 routesPath 用于后续 sentry 报错后 需记录的值
    const { history: { current: { name, matched } = {} } = {} } = getCurrentRouters();
    const routesPath = Array.isArray(matched) && matched.length > 0 ? matched[0].path : undefined;
    options.headers.currentPageKey = name;
    options.headers.routesPath = routesPath;

    options.headers.requestID = randomString(16);
    //在所有接口层加上子应用权限
    if (store.getters.getAppCodeKey) {
      options.headers.key = store.getters.getAppCodeKey;
    }

    // 服务号 或者滴滴授权页面
    if (loginType === 'wxmp' || (getQueryString('redirect') || '').includes('xiaojukeji')) {
      let realmId = store.getters.getUserToken && store.getters.getUserToken.realm_id;
      options.headers.realmId = realmId; //'639514855899537001';
    }

    if (language && options.url.indexOf('api/account') === -1) {
      options.headers.language = language;
    }

    if (options.url.indexOf('oauth/token') === -1) {
      options.headers.Authorization = 'Bearer' + token;
    } else {
      // 登录接口添加当前url记录 referUrl
      if (location.href && location.href.indexOf('&pwd=') > -1) {
        options.params && (options.params.referUrl = location.origin + location.pathname);
      } else {
        options.params && (options.params.referUrl = location.href);
      }
    }

    if (!instance) {
      instance = getInstance();
      interceptors(instance);
      interceptorsResponse(instance);
    }

    let proInstance = null;
    if (
      options.url.startsWith('/dingtalk/common') ||
      options.url.startsWith('/proxy') ||
      isAliCloud() ||
      options.url.startsWith('/wechat-service') ||
      (options.url.startsWith('/vendor-info-service') && isTcCloud())
    ) {
      if (!noBaseServrerInstance) {
        noBaseServrerInstance = getInstance({ noBaseServer: true });
        interceptors(noBaseServrerInstance);
        interceptorsResponse(noBaseServrerInstance);
      }
      ///api/trialService/ft/mobile/token/check' 无法记录真实ip这个接口不要走v1
      if (
        options.url.startsWith('/dingtalk/common') ||
        options.url.startsWith('/proxy') ||
        isAliCloud() ||
        options.url.startsWith('/wechat-service') ||
        (options.url.startsWith('/vendor-info-service') && isTcCloud()) ||
        options.url.includes('/api/trialService/ft/mobile/token/check')
      ) {
        proInstance = noBaseServrerInstance(options);
      } else {
        proInstance = instance(options);
      }
    } else if (isZhenxuanService(options.url)) {
      proInstance = getInstance({ noBaseServer: true, isZhenxuan: true })(options);
    } else {
      proInstance = instance(options);
    }
    let currentStamp = new Date().getTime();
    store.commit('setFetchKey', currentStamp);
    window?._helios_performance_monitoring?.markStart(options.url);
    proInstance
      .then((response) => {
        window?._helios_performance_monitoring?.markEnd(options.url, 'interface', options.headers.requestID);
        if (!store.state.fetchKeys.includes(currentStamp)) {
          return !1;
        }
        // store.commit("decreaseLoading")
        const res = response;
        removePending(options);
        resolve(res);
      })
      .catch((error) => {
        if (!store.state.fetchKeys.includes(currentStamp)) {
          return !1;
        }
        // store.commit("decreaseLoading");
        if (
          error.response &&
          error.response.config &&
          error.response.status === 401 &&
          error.response.config.url &&
          error.response.config.url.indexOf('oauth/token') === -1 &&
          (error.response.data.error == 'invalid_token' || error.response.data.error == 'Unauthorized') &&
          invalidTokenCount <= 8
        ) {
          invalidTokenCount = invalidTokenCount + 1;
          refreshToken(options).then(
            (res) => {
              removePending(options);
              resolve(res);
            },
            (err) => {
              // Vue.prototype.$RavenHttpError && Vue.prototype.$RavenHttpError(error, options);
              if (getQueryString('is_custom_menu') === 'Y') {
                hlyRouter.replace({ name: 'invalid-auth' });
              } else {
                goLoginPage();
              }
              removePending(options);
              if (error && error.message === 'hly-cancel-交易失败') {
                error.isCancel = true;
              }
              reject(error);
            }
          );
        } else {
          invalidTokenCount = 0;
          removePending(options);
          if (error && error.message === 'hly-cancel-交易失败') {
            error.isCancel = true;
            window?._helios_performance_monitoring?.markClear(options.url);
          } else {
            window?._helios_performance_monitoring?.markEnd(options.url, 'interface', options.headers.requestID);
          }
          reject(error);
        }
      });
  });
}

export function fetch(options) {
  if (options.url.startsWith('api/')) {
    options.url = '/' + options.url;
  }
  if (options.url.includes('/vendor-info-service') && options.url.includes('access_token=')) {
    options.url = clearUrlKey(options.url, 'access_token');
  }
  // options = getCustomOptions(options);
  if (config.nativeBusinessFlag && isIOS()) {
    try {
      if (!options.timeout) {
        options.timeout = 20000 * 6;
      }
      // options.timeout = 20
      return NativeService().nativeHttp(options);
    } catch (e) {}
  } else {
    return browseHttp(options);
  }
}

export function fetchByBrowseHttp(options) {
  if (options.url.startsWith('api/')) {
    options.url = '/' + options.url;
  }
  return browseHttp(options);
}

// 重置 axios 实例，因为实例的创建会 初始化 headers 里的 corpid
// 尝试了 axios.defaults.headers.common['corpid'] 给默认值 无效…… 所以还是 暴露个方法，在 url 的corpId 准备好后 重置一下 实例
export function resetInstance(corpId) {
  _resetInstance(corpId);
}
